// extracted by mini-css-extract-plugin
export default {"titleBox":"statistics_titleBox__Xf3aG","colBox":"statistics_colBox__usPDG","imgBox":"statistics_imgBox__tBYhb","textBox":"statistics_textBox__hvOcU"};